<div [class.hidden-on-init]="hideOnInit"
     [class.hide]="animationState === 'hide'"
     [class.padding-12]="padding === 'compact'"
     [class.padding-24]="padding === 'default'"
     [class.show]="animationState === 'show'"
     class="work-ui-sticky-footer">
  <ng-content></ng-content>
</div>
